
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PoApprovalGroupDialog extends Serenity.EntityDialog<PoApprovalGroupRow, any> {
        protected getFormKey() { return PoApprovalGroupForm.formKey; }
        protected getIdProperty() { return PoApprovalGroupRow.idProperty; }
        protected getLocalTextPrefix() { return PoApprovalGroupRow.localTextPrefix; }
        protected getNameProperty() { return PoApprovalGroupRow.nameProperty; }
        protected getService() { return PoApprovalGroupService.baseUrl; }
        protected getDeletePermission() { return PoApprovalGroupRow.deletePermission; }
        protected getInsertPermission() { return PoApprovalGroupRow.insertPermission; }
        protected getUpdatePermission() { return PoApprovalGroupRow.updatePermission; }

        protected form = new PoApprovalGroupForm(this.idPrefix);

    }
}